import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { get, isInteger } from 'lodash-es';
import 'react-table/react-table.css';
import { UncontrolledTooltip } from 'reactstrap';

class BuyNowGroup extends Component {
  state = {
    step: 1
  };

  async componentDidMount() {
    const { house: { bin: { catalogID } } } = this.props;
    const response = await axios(`/cps/app/diy-step-tracker/${catalogID}`);
    const step = get(response, 'data.data.steptracker', 1);
    this.setState({ step });
  }

  render() {
    const { house: { bin }, type, user: { accessReports } } = this.props;
    const {
      catalogID,
      catalogURL,
      groupID,
      invoiceGroupID,
      soldLotCount,
      unPubLotCount,
      unSoldLotCount
    } = bin;

    const { step } = this.state;

    if (Object.keys(bin).length <= 1) {
      return <div />;
    }

    const lotCount = type === 'current' ? unSoldLotCount : soldLotCount;

    const actions = {
      Header: 'Actions',
      id: 'actions',
      sortable: false,
      width: type === 'current' ? 265 : 284,
      Cell: () => {
        if (!isInteger(catalogID) || !isInteger(groupID)) {
          return null;
        }

        if (type === 'current') {
          return (
            <Link
              to={`/session/bin/${groupID}/${catalogID}/${step}`}
              aria-label="Edit Sale"
            >
              Edit Sale
            </Link>
          );
        }

        if (accessReports) {
          return <a href={`/ah/BiN/saleResults/${invoiceGroupID}`}>View Sale Results</a>;
        }

        return <div />;
      }
    };

    const columns = [
      {
        Header: 'Sale Name',
        id: 'title',
        accessor: 'Buy Now Sale',
        Cell: 'Buy Now Sale'
      },
      {
        Header: type === 'current' ? '# of Items' : 'Sold Items',
        width: 100,
        id: 'counts',
        Cell: () => {
          if (!isInteger(lotCount) || !isInteger(unPubLotCount)) {
            return null;
          }

          const binWarningText = `You have ${unPubLotCount} ${
            unPubLotCount === 1 ? 'unpublished lot' : 'unpublished lots'
          } in this session. Click "Edit Session" to publish your lots.`;
          return (
            <div>
              {type === 'current' && (
                <div className="align-right">
                  <span>
                    {unPubLotCount > 0 && (
                      <span>
                        <FontAwesomeIcon
                          id="binWarningIcon"
                          className="color-danger ml-2"
                          icon="exclamation-triangle"
                        />
                        <UncontrolledTooltip placement="right" target="binWarningIcon">
                          {binWarningText}
                        </UncontrolledTooltip>
                      </span>
                    )}

                    {lotCount > 0 && unPubLotCount === 0 && (
                      <FontAwesomeIcon icon="check" className="color-success" />
                    )}
                  </span>
                </div>
              )}
              <div className="align-right">{lotCount}</div>
            </div>
          );
        }
      },
      {
        Header: 'Preview Links',
        id: 'catalogID',
        sortable: false,
        width: 140,
        Cell: () => {
          if (!catalogURL) {
            return null;
          }

          return (
            <div>
              <a rel="noopener noreferrer" target="_blank" href={catalogURL}>
                Invaluable
              </a>
            </div>
          );
        }
      },
      actions
    ];

    return (
      <div className="mb-4">
        <div className="auction-container px-3">
          <FontAwesomeIcon icon="shopping-cart" /> <strong>Buy Now Sale</strong>
          {type === 'current' && (
            <span className="float-end">
              <Link
                className="link-secondary px-1"
                to={`/session/bin/${groupID}/${catalogID}/1`}
                aria-label="Edit Terms"
              >
                Edit Terms
              </Link>
            </span>
          )}
        </div>
        <ReactTable
          minRows={1}
          data={[bin]}
          defaultPageSize={500}
          columns={columns}
          showPagination={false}
          style={{ width: '100%' }}
          className="-highlight"
        />
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user
});

export default connect(
  mapStateToProps,
  null
)(BuyNowGroup);
